import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from '../common-modal/CommonModal';
import CommonButton from '../common-button/CommonButton';

import './ConfirmationModal.scss';

const ConfirmationModal = ({ isOpen, onClose, onCancel, onConfirm, label, subLabel }) => {
  const { t } = useTranslation();

  const handleConfirm = useCallback(() => {
    onConfirm();
    onClose();
  }, [onConfirm, onClose]);

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} wrapperClassName='confirmation-modal_wrapper' hideCloseIcon>
      <h3 className='confirmation-modal_text'>{label || t('areYouSure')}</h3>

      {subLabel ? <span className='confirmation-modal_sub-text'>{subLabel}</span> : null}

      <div className='confirmation-modal_actions'>
        <CommonButton type='button' styleColor='secondary' maxWidth={90} onClick={onCancel}>
          {t('no')}
        </CommonButton>

        <CommonButton type='button' styleColor='primary' maxWidth={90} onClick={handleConfirm}>
          {t('yes')}
        </CommonButton>
      </div>
    </CommonModal>
  );
};

export default memo(ConfirmationModal);
